import { Component } from 'react';
import styled, { css } from 'styled-components';
import { WebCategory } from '../../../../../../domain/model/category/WebCategory';
import { ISubCategory } from '../../../../../../public/template/pc/top/store/newsFeedTab';
import TabItemText from '../../../common/components/js/modules/TabItemText';
import TabList from '../../../common/components/js/modules/TabList';

interface IProps {
  category?: WebCategory;
  subCategories: ISubCategory[];
  changeTab: (subCategory: string, webCategory: WebCategory) => void;
  reflectStorage: () => void;
}

const Nav = styled.nav<{ $category: string | undefined }>`
  /* ライフタブ以外でborder-topを出す */
  ${({ $category }) =>
    $category !== 'life'
      ? css`
          border-top: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
        `
      : ''}
  border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv1_pc};
`;

export default class NewsFeedTab extends Component<IProps> {
  /**
   *
   */
  public componentDidMount() {
    // localstorageの内容を反映する
    this.props.reflectStorage();
  }

  /**
   *
   */
  public render() {
    const items = this.props.subCategories.map((subCategory, index) => {
      const sec = this.getSecStringByCategoryId(this.props.category) || '';
      const slk = this.getSlkStringByCategoryIds(this.props.category, subCategory) || '';
      const dataClParams = `_cl_vmodule:${sec};_cl_link:${slk};`;

      return (
        <TabItemText
          name={subCategory.name}
          isCurrent={subCategory.isCurrent}
          isFontSizeLarge={false}
          isSpaced={false}
          dataClParams={dataClParams}
          key={subCategory.name}
          onclick={() => {
            if (this.props.category) {
              this.props.changeTab(subCategory.id, this.props.category);
            }
          }}
        />
      );
    });

    return (
      <Nav $category={this.props.category}>
        <TabList tabType="text">{items}</TabList>
      </Nav>
    );
  }

  /**
   * categoryIdより、sec用の文字列取得
   *
   * @param categoryId
   */
  private getSecStringByCategoryId(categoryId?: WebCategory): string | undefined {
    if (!categoryId) {
      return undefined;
    }
    switch (categoryId) {
      case WebCategory.DOMESTIC:
        return 'stnv_dom';
      case WebCategory.WORLD:
        return 'stnv_wor';
      case WebCategory.BUSINESS:
        return 'stnv_bus';
      case WebCategory.ENTERTAINMENT:
        return 'stnv_ent';
      case WebCategory.SPORTS:
        return 'stnv_spo';
      case WebCategory.IT:
        return 'stnv_it';
      case WebCategory.SCIENCE:
        return 'stnv_sci';
      case WebCategory.LIFE:
        return 'stnv_lif';
    }
    return undefined;
  }
  /**
   * categoryIdと、サブカテゴリIDより、slk用の文字列取得
   *
   * @param categoryId
   * @param subCategory
   */
  private getSlkStringByCategoryIds(categoryId?: WebCategory, subCategory?: ISubCategory): string | undefined {
    if (!categoryId || !subCategory) {
      return undefined;
    }
    if (subCategory.id === 'new') {
      switch (categoryId) {
        case WebCategory.DOMESTIC:
          return 'n_dom';
        case WebCategory.WORLD:
          return 'n_wor';
        case WebCategory.BUSINESS:
          return 'n_bus';
        case WebCategory.ENTERTAINMENT:
          return 'n_ent';
        case WebCategory.SPORTS:
          return 'n_spo';
        case WebCategory.IT:
          return 'n_it';
        case WebCategory.SCIENCE:
          return 'n_sci';
        case WebCategory.LIFE:
          return 'n_lif';
      }
    }
    return subCategory.id;
  }
}
